import { render, staticRenderFns } from "./CorrecaoTitulo.vue?vue&type=template&id=af4b82fe"
import script from "./CorrecaoTitulo.vue?vue&type=script&lang=js"
export * from "./CorrecaoTitulo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af4b82fe')) {
      api.createRecord('af4b82fe', component.options)
    } else {
      api.reload('af4b82fe', component.options)
    }
    module.hot.accept("./CorrecaoTitulo.vue?vue&type=template&id=af4b82fe", function () {
      api.rerender('af4b82fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CorrecaoTitulo.vue"
export default component.exports